module.exports = __webpack_public_path__ + "media/images/Acteur engagé-24b960c0d372cef470d5ad9746655e71.svg";